import { BANNER_HEIGHT, DRAWER_WIDTH, TOP_BAR_HEIGHT } from '@ucc/unified-admin-common'

export { BANNER_HEIGHT, DRAWER_WIDTH, TOP_BAR_HEIGHT }
export const CC_FREE_TRIAL_BANNER_HEIGHT = 64
export const DEFAULT_PAGINATION_SIZE = 50
export const SIDEBAR_WIDTH = 256
export const INTERCOM_APP_ID = 'aavfp0qd'
export const COUNTRY_CODE_US = 'US'
export const HOME_KEY = 'home'
export const HIGHLIGHT_DURATION = 5000
export const HIGHLIGHT_DELAY = 500
export const SNACKBAR_DURATION = 5000
export const TYPING_DEBOUNCE_MILLISECONDS = 275
export const FEATURE_FLAGS = {
  adminDashboard: 'admin.it.dashboard',
  adminSipTrunks: 'admin.devices.sip_trunk',
  allowCustomerEngagementLicense: 'pbx.license.customer-engagement',
  directories: 'gotoadmin.directories',
  settingsTemplate: 'admin.settings.template',
  tryNew: 'gotoadmin.try-new',
  integrations: 'gotoadmin.integrations',
  rebranding2021: 'admin.rebranding2021',
  useDynamicSetupConfig: 'use.dynamic.setup.config',
  smsCampaignRegistration: 'sms.campaign.registration',
  newUserPhoneSettings: 'gotoadmin.new-user-phone-settings',
  virtualReceptionist: 'pbx.virtual-receptionist.v1',
}
export const UNLEASH_FEATURE_FLAGS = {
  billingAdminUserManagement: 'billing.admin.user.management',
  gotoAdminContacts: 'gotoadmin.contacts',
  tabletAccess: 'tablet.access',
  copilotAI: 'copilot.ai',
  searchAccountsDropdown: 'search.accounts.dropdown',
  ccConfigurationVersion: 'cc-config-version',
  tenants: 'admin.enable.tenants',
  showLaunchpad: 'show-launchpad',
  resolveRebranding: 'resolve-rebranding',
  contactsVersion: 'contacts-version',
  dceVersion: 'engagements.version',
  inboxSettingsIntegration: 'engagements.admin-inbox-settings',
}
export const BOLDCHAT_ACCOUNT_ID = '744269138093162628'
export const BOLDCHAT_ADD_FLOAT_ID = '739548189281549221'
export const SUPPORTED_LOCALES = [
  'de_DE',
  'en_GB',
  'en_US',
  'es_ES',
  'fr_FR',
  'it_IT',
  'ja_JP',
  'ko_KR',
  'pt_BR',
  'zh_CN',
]
export const VAT_COUNTRIES_SUPPORTED = [
  'AE',
  'AT',
  'AU',
  'BE',
  'BG',
  'BY',
  'CH',
  'CY',
  'CZ',
  'DE',
  'DK',
  'EE',
  'ES',
  'FI',
  'FR',
  'GB',
  'GR',
  'HR',
  'HU',
  'IE',
  'IN',
  'IS',
  'IT',
  'KR',
  'LT',
  'LU',
  'LV',
  'MT',
  'MX',
  'NL',
  'NO',
  'NZ',
  'PL',
  'PT',
  'RO',
  'RU',
  'SE',
  'SI',
  'SK',
  'TR',
  'TW',
  'ZA',
]
export const DEFAULT_LOCALE = 'en_US'

export const APPLICATION_ADMIN = 'admin-portal'
export const APPLICATION_ANALYTICS = 'analytics'
export const APPLICATION_JIVE_BILLING = 'jive-billing'
export const APPLICATION_BOSS_BILLING = 'boss-billing'
export const APPLICATION_CALL_REPORTS = 'call-reports'
export const APPLICATION_CONTACT_CENTER = 'contact-center'
export const APPLICATION_INTEGRATIONS = 'integrations'
export const APPLICATION_UNIFIED_ADMIN = 'unified-admin'

export const MINIMUM_ACCOUNT_NUMBER_TO_SHOW_SEARCH_FIELD = 10

export const CHANNEL_BOSS = 'BOSS'
export const CHANNEL_TITAN = 'TITAN'
export const CHANNEL_STERLING = 'STERLING'
export const CHANNEL_JIVE = 'jive'

export const RESOLVE_TRIAL_ROUTE = 'resolve-trial'
export const ZERO_TRUST_ROUTE = 'zero-trust'
export const CURRENCY_IN = 'INR'

export const LOGGER_SETTINGS_STORAGE_FLAG = 'gotoLoggerSettings'

export const SHOW_GOTO_ADMIN_TOUR = 'show-goto-admin-tour'

export const SHOW_ADMIN_TOUR_POPOVER = 'show-admin-tour-pop-over'

export const SHOW_ADMIN_TOUR_FIRST_TIME = 'show-admin-tour-first-time'

export enum GTATourLengthByRole {
  PRODUCT_ADMIN_TOUR_MAX_LENGTH = 5,
  PRODUCT_BILLING_ADMIN_TOUR_MAX_LENGTH = 6,
}

export enum GTATourFeatureDot {
  FIRST_SCREEN_ACTIVE = 0,
  SECOND_SCREEN_ACTIVE = 1,
  THIRD_SCREEN_ACTIVE = 2,
  FOURTH_SCREEN_ACTIVE = 3,
  FIFTH_SCREEN_ACTIVE = 4,
}
export const QUALTRICS_SURVEY_TRIGGER_TYPES = {
  timer: 'Timer',
  success: 'SuccessMessage',
  error: 'ErrorMessage',
  review: 'Week2Review',
  switchback: 'SwitchBack',
}

export const GOTOADMIN_FORCED_SWITCHOVER_DATE = '2024-03-31'

export enum PbxType {
  CUSTOMER = 'CUSTOMER',
  DEMO = 'DEMO',
  TEST = 'TEST',
  EMPLOYEE = 'EMPLOYEE',
  TRAINING = 'TRAINING',
  LMI = 'LMI',
}

export const SMS_CAMPAIGN_NUMBER_POOL_APPROVAL_URL =
  'https://support.goto.com/download/sms-campaign-number-pool-approval'

export const SMS_CAMPAIGN_NUMBER_POOL_APPROVAL_MAILTO = 'numbers@goto.com'

export const PASSKEY_PROMOTIONS_LEARN_MORE_URL =
  'https://support.goto.com/connect/help/create-and-manage-passkeys-for-sign-in'
